export default {
  data() {
    return {
      selectedRows: [],
      shiftKeyOn: false,
      current: [],
    };
  },
  created() {
    const self = this;
    self.keyDownHandler = function ({ key }) {
      if (key == "Shift") self.shiftKeyOn = true;
    };
    self.keyUpHandler = function ({ key }) {
      if (key == "Shift") self.shiftKeyOn = false;
    };
    window.addEventListener("keydown", this.keyDownHandler);
    window.addEventListener("keyup", this.keyUpHandler);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDownHandler);
    window.removeEventListener("keyup", this.keyUpHandler);
  },

  methods: {
    bulkSelect({ item: b, value }) {
      const { selectedRows, current, shiftKeyOn } = this;
      if (selectedRows.length >= 1 && value == true && shiftKeyOn) {
        //const [a] = selectedRows;
        const a = selectedRows.at(-1);
        let start = current.findIndex((item) => item == a);
        let end = current.findIndex((item) => item == b);
        if (start - end > 0) {
          let temp = start;
          start = end;
          end = temp;
        }
        for (let i = start; i <= end; i++) {
          selectedRows.push(current[i]);
        }
        //this.selectedRows = {...selectedRows};
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ListBulkSelect.js